module.exports = __webpack_public_path__ + "static/media/nielson.d62132e7.png";